/**
 * When the guard may send a signed-out donor straight to the hosted sign-in
 * page, rather than stopping on our login page.
 *
 * Automatic redirects need a loop breaker. If the API keeps refusing the token --
 * email_verified false on the account, a client id that does not match the API's
 * -- the cycle would be: dashboard, 401, redirect to the hosted page, single
 * sign-on returns a code at once, dashboard, 401, forever, with the donor seeing
 * nothing but flicker. So an automatic sign-in happens at most once per cooldown.
 * Inside it, the guard falls back to the login page and its button, which needs a
 * click and so cannot loop.
 *
 * The timestamp sits under the donorPortal. prefix on purpose: signing out clears
 * that prefix, so a deliberate sign-out never leaves the next visit throttled.
 */

const KEY = 'donorPortal.autoSignInAt';

export const AUTO_SIGN_IN_COOLDOWN_MS = 2 * 60 * 1000;

export const mayAutoSignIn = (now = Date.now()) => {
    try {
        const last = Number(window.sessionStorage.getItem(KEY));
        return !(last && now - last < AUTO_SIGN_IN_COOLDOWN_MS);
    } catch (e) {
        // Without storage there is no way to notice a loop -- and sign-in cannot
        // work anyway, since PKCE state lives there. Let the donor click instead.
        return false;
    }
};

export const recordAutoSignIn = (now = Date.now()) => {
    try {
        window.sessionStorage.setItem(KEY, String(now));
    } catch (e) {
        /* mayAutoSignIn already returned false in this case */
    }
};
